var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-editor", {
    attrs: {
      entity: "encounter",
      id: _vm.id,
      "new-entity": _vm.newEncounter,
      copy: _vm.copy
    },
    on: {
      isDirtyChange: _vm.handleIsDirtyChange,
      entityLoaded: _vm.encounterLoaded
    },
    scopedSlots: _vm._u(
      [
        {
          key: `editor`,
          fn: function({ doc }) {
            return [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.events,
                          "item-text": "name",
                          "item-value": "id",
                          disabled: _vm.isLoading,
                          label: "Event",
                          outlined: "",
                          dense: "",
                          readonly: _vm.isEncounterTimeLocked
                        },
                        on: { change: _vm.eventIdChanged },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Event" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.eventId,
                          callback: function($$v) {
                            _vm.$set(doc, "eventId", $$v)
                          },
                          expression: "doc.eventId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          readonly: "",
                          dense: "",
                          label: "Encounter Day and Time"
                        },
                        on: {
                          click: function($event) {
                            _vm.showSlotPicker = !_vm.isEncounterTimeLocked
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Encounter Day and Time" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.dayAndTime,
                          callback: function($$v) {
                            _vm.dayAndTime = $$v
                          },
                          expression: "dayAndTime"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      [
                        _c("v-combobox", {
                          attrs: {
                            items: _vm.encounterTags,
                            chips: "",
                            clearable: "",
                            label: "Encounter Tags",
                            multiple: "",
                            outlined: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function({
                                  attrs,
                                  item,
                                  select,
                                  selected
                                }) {
                                  return [
                                    _c(
                                      "v-chip",
                                      _vm._b(
                                        {
                                          attrs: {
                                            "input-value": selected,
                                            close: ""
                                          },
                                          on: {
                                            click: select,
                                            "click:close": function($event) {
                                              doc.tags.splice(
                                                doc.tags.indexOf(item),
                                                1
                                              )
                                            }
                                          }
                                        },
                                        "v-chip",
                                        attrs,
                                        false
                                      ),
                                      [_c("strong", [_vm._v(_vm._s(item))])]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: doc.tags,
                            callback: function($$v) {
                              _vm.$set(doc, "tags", $$v)
                            },
                            expression: "doc.tags"
                          }
                        })
                      ]
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.encounterTypes,
                          disabled: _vm.isLoading,
                          label: "Encounter Type",
                          outlined: "",
                          dense: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Encounter Type" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.encounterType,
                          callback: function($$v) {
                            _vm.$set(doc, "encounterType", $$v)
                          },
                          expression: "doc.encounterType"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.priorities,
                          disabled: _vm.isLoading,
                          label: "Priority",
                          outlined: "",
                          dense: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Priority" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.priority,
                          callback: function($$v) {
                            _vm.$set(doc, "priority", $$v)
                          },
                          expression: "doc.priority"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.refCover,
                          disabled: _vm.isLoading,
                          label: "Ref Cover Required",
                          outlined: "",
                          dense: ""
                        },
                        model: {
                          value: doc.refCoverNeeded,
                          callback: function($$v) {
                            _vm.$set(doc, "refCoverNeeded", $$v)
                          },
                          expression: "doc.refCoverNeeded"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.sortedPlots,
                          disabled: _vm.isLoading,
                          label: "Plot",
                          outlined: "",
                          dense: "",
                          clearable: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Plot" }
                                  })
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "selection",
                              fn: function(data) {
                                return [
                                  _vm._v(" " + _vm._s(data.item.text) + " "),
                                  _c("approval-status", {
                                    attrs: { status: data.item.statusId }
                                  })
                                ]
                              }
                            },
                            {
                              key: "item",
                              fn: function(data) {
                                return [
                                  _vm._v(" " + _vm._s(data.item.text) + " "),
                                  _c("approval-status", {
                                    attrs: { status: data.item.statusId }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.plotKeyId,
                          callback: function($$v) {
                            _vm.$set(doc, "plotKeyId", $$v)
                          },
                          expression: "doc.plotKeyId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          outlined: "",
                          dense: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Name" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.name,
                          callback: function($$v) {
                            _vm.$set(doc, "name", $$v)
                          },
                          expression: "doc.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.inOutOptions,
                          label: "Inbound",
                          rows: "2",
                          outlined: "",
                          dense: "",
                          rules: [_vm.requiredRuleValidZero]
                        },
                        model: {
                          value: doc.inbound,
                          callback: function($$v) {
                            _vm.$set(doc, "inbound", $$v)
                          },
                          expression: "doc.inbound"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "9" } },
                    [
                      doc.inbound === 1
                        ? _c("v-autocomplete", {
                            attrs: {
                              items: _vm.transportCircles,
                              outlined: "",
                              dense: "",
                              label: "Transport in from...",
                              clearable: "",
                              "open-on-clear": "",
                              rules: [_vm.requiredRule]
                            },
                            model: {
                              value: doc.inboundCircleKeyId,
                              callback: function($$v) {
                                _vm.$set(doc, "inboundCircleKeyId", $$v)
                              },
                              expression: "doc.inboundCircleKeyId"
                            }
                          })
                        : _vm._e(),
                      doc.inbound > 1
                        ? _c("v-textarea", {
                            attrs: {
                              label: "Inbound Details",
                              rows: "2",
                              outlined: "",
                              "auto-grow": "",
                              rules: [_vm.requiredRule]
                            },
                            model: {
                              value: doc.inboundDetails,
                              callback: function($$v) {
                                _vm.$set(doc, "inboundDetails", $$v)
                              },
                              expression: "doc.inboundDetails"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.inOutOptions,
                          label: "Outbound",
                          rows: "2",
                          outlined: "",
                          dense: "",
                          rules: [_vm.requiredRuleValidZero]
                        },
                        model: {
                          value: doc.outbound,
                          callback: function($$v) {
                            _vm.$set(doc, "outbound", $$v)
                          },
                          expression: "doc.outbound"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "9" } },
                    [
                      doc.outbound === 1
                        ? _c("v-autocomplete", {
                            attrs: {
                              items: _vm.transportCircles,
                              outlined: "",
                              dense: "",
                              label: "Transport out to...",
                              clearable: "",
                              "open-on-clear": "",
                              rules: [_vm.requiredRule]
                            },
                            model: {
                              value: doc.outboundCircleKeyId,
                              callback: function($$v) {
                                _vm.$set(doc, "outboundCircleKeyId", $$v)
                              },
                              expression: "doc.outboundCircleKeyId"
                            }
                          })
                        : _vm._e(),
                      doc.outbound > 1
                        ? _c("v-textarea", {
                            attrs: {
                              label: "Outbound Details",
                              rows: "2",
                              outlined: "",
                              "auto-grow": "",
                              rules: [_vm.requiredRule]
                            },
                            model: {
                              value: doc.outboundDetails,
                              callback: function($$v) {
                                _vm.$set(doc, "outboundDetails", $$v)
                              },
                              expression: "doc.outboundDetails"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Description",
                          rows: "5",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.description,
                          callback: function($$v) {
                            _vm.$set(doc, "description", $$v)
                          },
                          expression: "doc.description"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.costumeLevels,
                          label: "Costume Level",
                          rows: "2",
                          outlined: "",
                          dense: ""
                        },
                        model: {
                          value: doc.costumeLevel,
                          callback: function($$v) {
                            _vm.$set(doc, "costumeLevel", $$v)
                          },
                          expression: "doc.costumeLevel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "9" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Costume",
                          rows: "2",
                          outlined: "",
                          "auto-grow": "",
                          disabled: doc.costumeLevel === 0,
                          "background-color":
                            doc.costumeLevel === 0
                              ? _vm.$vuetify.theme.dark
                                ? `grey darken-4`
                                : `grey lighten-2`
                              : ""
                        },
                        model: {
                          value: doc.costumeNotes,
                          callback: function($$v) {
                            _vm.$set(doc, "costumeNotes", $$v)
                          },
                          expression: "doc.costumeNotes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.makeupLevels,
                          label: "Makeup Notes",
                          rows: "2",
                          outlined: "",
                          dense: ""
                        },
                        model: {
                          value: doc.makeupLevel,
                          callback: function($$v) {
                            _vm.$set(doc, "makeupLevel", $$v)
                          },
                          expression: "doc.makeupLevel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "9" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Makeup Notes",
                          rows: "2",
                          outlined: "",
                          "auto-grow": "",
                          disabled: doc.makeupLevel === 0,
                          "background-color":
                            doc.makeupLevel === 0
                              ? _vm.$vuetify.theme.dark
                                ? `grey darken-4`
                                : `grey lighten-2`
                              : ""
                        },
                        model: {
                          value: doc.makeupNotes,
                          callback: function($$v) {
                            _vm.$set(doc, "makeupNotes", $$v)
                          },
                          expression: "doc.makeupNotes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12", sm: "2" } }, [
                    _c("span", { staticClass: "font-weight-medium" }, [
                      _vm._v("Monsters")
                    ])
                  ])
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-3", attrs: { light: "" } }),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "1" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          type: "number",
                          dense: "",
                          min: "0"
                        },
                        model: {
                          value: _vm.newMonster.minQuantity,
                          callback: function($$v) {
                            _vm.$set(_vm.newMonster, "minQuantity", $$v)
                          },
                          expression: "newMonster.minQuantity"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "1" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          type: "number",
                          dense: "",
                          min: "0"
                        },
                        model: {
                          value: _vm.newMonster.maxQuantity,
                          callback: function($$v) {
                            _vm.$set(_vm.newMonster, "maxQuantity", $$v)
                          },
                          expression: "newMonster.maxQuantity"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "9" } },
                    [
                      _c("monster-picker", {
                        attrs: { "plot-id": doc.plotKeyId },
                        on: { selected: _vm.getMonster }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "1" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            title: "Add Monster",
                            color: "success",
                            disabled: !_vm.canAddMonster
                          },
                          on: {
                            click: function($event) {
                              return _vm.addMonster(doc)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-plus")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.newMonster.stats
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "10" } },
                        [
                          _c("monster-summary", {
                            attrs: { monster: _vm.newMonster.stats }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-divider", { staticClass: "my-3", attrs: { light: "" } }),
              _vm._l(doc.monsters, function(monster, i) {
                return _c(
                  "v-row",
                  { key: i },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "1" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            outlined: "",
                            type: "number",
                            dense: "",
                            min: "0"
                          },
                          model: {
                            value: monster.minQuantity,
                            callback: function($$v) {
                              _vm.$set(monster, "minQuantity", $$v)
                            },
                            expression: "monster.minQuantity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "1" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            outlined: "",
                            type: "number",
                            dense: "",
                            min: "0"
                          },
                          model: {
                            value: monster.maxQuantity,
                            callback: function($$v) {
                              _vm.$set(monster, "maxQuantity", $$v)
                            },
                            expression: "monster.maxQuantity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "9" } },
                      [
                        _c(
                          "v-expansion-panels",
                          { attrs: { accordion: "", tile: "", hover: "" } },
                          [
                            _c(
                              "v-expansion-panel",
                              [
                                _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "py-1 pl-3" },
                                  [
                                    _c(
                                      "span",
                                      [
                                        _c("span", { staticClass: "mr-2" }, [
                                          _vm._v(_vm._s(monster.stats.name))
                                        ]),
                                        _c("approval-status", {
                                          attrs: {
                                            status: monster.stats.statusId
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "v-expansion-panel-content",
                                  [
                                    _c("monster-summary", {
                                      attrs: { monster: monster.stats }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("v-textarea", {
                          staticClass: "mt-3",
                          attrs: {
                            label: "Notes",
                            outlined: "",
                            rows: "1",
                            "auto-grow": ""
                          },
                          model: {
                            value: monster.notes,
                            callback: function($$v) {
                              _vm.$set(monster, "notes", $$v)
                            },
                            expression: "monster.notes"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "1" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { title: "Remove Monster", color: "error" },
                            on: {
                              click: function($event) {
                                return _vm.removeMonster(
                                  doc,
                                  monster.stats.keyId
                                )
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-minus")])],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "900" },
                  model: {
                    value: _vm.showSlotPicker,
                    callback: function($$v) {
                      _vm.showSlotPicker = $$v
                    },
                    expression: "showSlotPicker"
                  }
                },
                [
                  _c(
                    "v-card",
                    { attrs: { tile: "", "data-card": "" } },
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { dark: "", color: "secondary" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "", "data-close": "" },
                              on: {
                                click: function($event) {
                                  _vm.showSlotPicker = false
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                          _c("v-toolbar-title", [
                            _vm._v(
                              _vm._s(_vm.event ? _vm.event.name : "") +
                                " - Select Encounter Time"
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c("event-time-table", {
                            attrs: {
                              event: _vm.event,
                              "slot-data": _vm.slotData,
                              "is-select-mode": ""
                            },
                            on: {
                              slotSelected: (eventDayId, time) =>
                                _vm.handleSlotSelected(doc, eventDayId, time)
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }